const isDev = import.meta.env.DEV;

export const devDefaults = isDev
  ? {
      first_name: import.meta.env.VITE_DEV_FIRST_NAME ?? '',
      last_name: import.meta.env.VITE_DEV_LAST_NAME ?? '',
      email: import.meta.env.VITE_DEV_EMAIL ?? '',
      phone: import.meta.env.VITE_DEV_PHONE ?? '',
    }
  : {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
    };
